var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { class: _vm.cssClass, attrs: { for: _vm.item.data.id } },
    [
      _c("span", { staticClass: "origin" }, [
        _vm._v("\n        " + _vm._s(_vm.item.data.question) + " "),
        _vm.item.data.mandatory
          ? _c("span", { staticClass: "mandatory" }, [_vm._v("*")])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isInvalid
        ? _c("span", { staticClass: "error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }